export default __webpack_public_path__ + "static/media/logo_white.835e18a7.svg";